/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { FontIcon } from "@fluentui/react";

/**
 * Arrow icon used to indicate "next" or "back".
 * @param {name} name icon name property.
 * @returns {React.ReactElement} FontIcon chevron arrow element.
 */
const ChevronIcon = (name: string): React.ReactElement => <FontIcon iconName={name} />;

export default ChevronIcon;
